import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget as dropTarget } from 'react-dnd';
import styles from './SubsectionDropZone.scss';

class SubsectionDropZone extends React.Component {
  static propTypes = {
    accepts: PropTypes.arrayOf(PropTypes.string).isRequired,
    onDrop: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    children: PropTypes.any,
    canDrop: PropTypes.bool.isRequired,
    isOver: PropTypes.bool.isRequired,
  };

  render() {
    const {
      children, connectDropTarget, canDrop, isOver,
    } = this.props;
    const useTheseStyles = [styles.notCompletelyInvisible];
    if (canDrop) {
      useTheseStyles.push(styles.canDrop);
      if (isOver) useTheseStyles.push(styles.isOver);
    }

    return connectDropTarget(
      <div className={useTheseStyles.join(' ')}>
        {children}
      </div>,
    );
  }
}

export default dropTarget(
  props => props.accepts,
  {
    drop(props, monitor) {
      props.onDrop(monitor.getItem());
    },
  },
  (collect, monitor) => ({
    connectDropTarget: collect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(SubsectionDropZone);
